<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <label style="font-size: 15px !important">Arquivo CTB x FIS (Base contábil)</label>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                <div>
                  <a href="javascript:void(0)" @click="baixarArquivoModeloBaseContabil()">Clique aqui</a>
                  para baixar o modelo para a importação.
                  <br />
                  OBS: O arquivo enviado precisa estar no formato
                  <b>UTF-8</b>
                  .
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-file-input
                  v-model="arquivoBaseContabilFileObj"
                  label="Arquivo CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv"
                  truncate-length="30"
                  :loading="arquivoBaseContabilUploading"
                  loader-height="4"
                  :success="arquivoBaseContabilId && arquivoBaseContabilFileObj ? true : false"
                  :error-messages="errors"
                  @change="uploadNewFile($event)"
                  @click:clear="clearInputsArquivo()"
                />
              </validation-provider>
              <input type="hidden" name="upload-arquivo-base-contabil" :value="arquivoBaseContabilId" />
            </v-col>
          </v-row>
          <v-row class="mb-n5 mt-n2 mx-auto">
            <v-col cols="12" class="pl-n1 pt-0">
              <parametros-arquivo-csv
                :delimitador.sync="arquivoBaseContabilDelimitador"
                :involucro.sync="arquivoBaseContabilInvolucro"
                :escape.sync="arquivoBaseContabilEscape"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import SimulacoesLaudosIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';
  import ArquivosService from '@/services/ArquivosService';

  export default {
    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },

    data: () => ({
      cabecalhoArquivo: [
        'Id_SEQ_INC',
        'Cd_CC',
        'CD_ODI',
        'CD_SubODI',
        'Nr_TI',
        'Nr_CM',
        'Nr_TUC',
        'Nr_A1',
        'Nr_A2',
        'Nr_A3',
        'Nr_A4',
        'Nr_A5',
        'Nr_A6',
        'Cd_UAR',
        'Cd_UC',
        'Cd_Patrim',
        'Cd_DIG_INC',
        'txt_Desc_Bem',
        'COD_ITEM',
        'DESCR_ITEM',
        'Id_BP',
        'Qtd_AIS',
        'Cd_UND_AIS',
        'VL_VOC',
        'Dt_Imob',
        'VL_DEP_ACUM',
        'VL_VOC_VF',
        'VL_VOC_COM',
        'VL_VOC_CA',
        'VL_VOC_JOA',
        'FLG_ELIG',
        'Cd_CONC',
        'Cd_Q1_AVAL'
      ]
    }),

    computed: {
      arquivoBaseContabilId: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoBaseContabil.id;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoBaseContabil: { id: value } });
        }
      },
      arquivoBaseContabilFileObj: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoBaseContabil.fileObj;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoBaseContabil: { fileObj: value } });
        }
      },
      arquivoBaseContabilUploading: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoBaseContabil.uploading;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoBaseContabil: { uploading: value } });
        }
      },
      arquivoBaseContabilDelimitador: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoBaseContabil.delimitador;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoBaseContabil: { delimitador: value } });
        }
      },
      arquivoBaseContabilInvolucro: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoBaseContabil.involucro;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoBaseContabil: { involucro: value } });
        }
      },
      arquivoBaseContabilEscape: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoBaseContabil.escape;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoBaseContabil: { escape: value } });
        }
      }
    },

    methods: {
      baixarArquivoModeloBaseContabil() {
        this.$toast.info('Processando...', '', {
          position: 'topRight',
          timeout: 1250
        });

        SimulacoesLaudosIncrementaisService.baixarArquivoModeloBaseContabil()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', 'Arquivo Base Contabil Modelo.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo do sistema', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      },

      uploadNewFile(arquivo) {
        if (!arquivo) {
          this.clearInputsArquivo();
          return true;
        }

        this.arquivoBaseContabilId = '';
        this.arquivoBaseContabilUploading = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile, {})
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoBaseContabilDelimitador,
              this.arquivoBaseContabilInvolucro,
              this.arquivoBaseContabilEscape,
              this.cabecalhoArquivo
            );

            this.arquivoBaseContabilId = response.data.arquivoId;
          })
          .catch((err) => {
            if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
              this.$toast.error(err.data.erro, '', {
                position: 'topRight',
                timeout: 6000
              });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', {
                position: 'topRight'
              });
              console.error('Erro ao fazer upload: ', err);
            }

            this.arquivoBaseContabilFileObj = null;
          })
          .finally(() => (this.arquivoBaseContabilUploading = false));
      },

      clearInputsArquivo() {
        this.arquivoBaseContabilId = '';
        this.arquivoBaseContabilFileObj = null;
        this.arquivoBaseContabilDelimitador = ';';
        this.arquivoBaseContabilInvolucro = '"';
        this.arquivoBaseContabilEscape = '"';

        this.$forceUpdate();
      },

      validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
        return ArquivosService.validarHeaderCSV(arquivoId, {
          delimitador,
          involucro,
          escape,
          cabecalhoEsperado
        }).catch((err) => {
          throw err;
        });
      }
    }
  };
</script>
